import CryptoJS from 'crypto-js'
import forge from 'node-forge'
import { environment, public_key } from 'constants/config'

const Base64DecodeUrl = (str: string) => {
  str = (str + '===').slice(0, str.length + (str.length % 4))
  return str.replace(/-/g, '+').replace(/_/g, '/')
}

export const hash = (text: string) => {
  if (environment !== 'local') {
    return CryptoJS.SHA256(text).toString()
  }
  return text
}

export const encryptAsRsa = (text: string) => {
  if (environment !== 'local') {
    const keyRsa = public_key
    const rsaKey = Base64DecodeUrl(keyRsa)
    const publicKey = forge.pki.publicKeyFromPem(
      `-----BEGIN PUBLIC KEY----- ${rsaKey} -----END PUBLIC KEY-----`,
    )
    const encrypted = publicKey.encrypt(text, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: { md: forge.md.sha256.create() },
    })
    const encryptedBase64 = forge.util.encode64(encrypted)
    return encryptedBase64
  }
  return text
}
